module.exports = __webpack_public_path__ + "static/img/submit-sucess.a68084a.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/submitWorkOrder/submit-sucess.png
// module id = 0vCG
// module chunks = 86